import { store } from './store';
import { firebase, db } from './firebase';

const nullUser = {
  isLoggedIn: false,
  isAdmin: false,
  username: '',
  fullName: ''
};

async function getFirebaseSession() {
  let firebaseUser = firebase.auth().currentUser;
  let user = {};
  if (firebaseUser) {
    await firebaseUser.getIdToken().then(token => {
      const tokenDataEncoded = token.split('.')[1];
      const tokenData = JSON.parse(atob(tokenDataEncoded));
      user = {
        isLoggedIn: true,
        isAdmin: tokenData.isAdmin,
        username: tokenData.user_id,
        fullName: tokenData.fullName,
        meetings: {}
      };
    });
  }
  return user;
}

function getOpenMeetingDocs() {
  return db
    .collection('meetings')
    .where('phase_index', '>', 0)
    .get()
    .then(querySnapshot => {
      if (querySnapshot.empty) {
        return [];
      } else {
        return querySnapshot.docs;
      }
    });
}

function getUserDataFromMeetingDoc(meetingDoc, user) {
  let username = user.username;
  let meetingData = meetingDoc.data();
  return meetingDoc.ref
    .collection('users')
    .doc(username)
    .get()
    .then(userDoc => {
      if (userDoc.exists) {
        let userData = userDoc.data();
        let returnedData = {
          meeting_name: meetingData.name,
          company_id: userData.company_id,
          phase_index: meetingData.phase_index,
          suites: userData.suites,
          type: userData.type
        };
        if (Object.keys(userData.suites).length > 0) {
          return [meetingDoc.id, returnedData];
        }
      }
    });
}

async function attachMeetingDataToUser(userData) {
  await getOpenMeetingDocs()
    .then(queryDocs => {
      return Promise.all(
        queryDocs.map(queryDoc => getUserDataFromMeetingDoc(queryDoc, userData))
      );
    })
    .then(userDocs => {
      userDocs.forEach(meetingData => {
        if (meetingData) {
          userData.meetings[meetingData[0]] = meetingData[1];
        }
      });
    });

  return userData;
}

export default {
  fetchJWT(to) {
    const pathOnReturn = to.fullPath;
    localStorage.setItem('appPath', pathOnReturn);
    window.location =
      process.env.MAXX_DOMAIN +
      '/forms/api/getJWT?service=' +
      process.env.DOMAIN +
      '/%23/receiveToken';
  },

  authenticateFirebase(token) {
    let initialPromise = Promise.resolve(null);
    if (token) {
      initialPromise = firebase.auth().signInWithCustomToken(token);
    }
    return initialPromise
      .then(_ => {
        return getFirebaseSession();
      })
      .then(async userData => {
        if (!userData.isAdmin) {
          userData = await attachMeetingDataToUser(userData);
        }
        return userData;
      })
      .then(userData => {
        store.commit('setUser', userData);
      })
      .catch(error => {
        console.log('sign in error: ' + error);
      });
  },

  logout() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        localStorage.removeItem('token');
        store.commit('setUser', nullUser);
        window.location = process.env.MAXX_DOMAIN + '/forms/cas/logout';
      })
      .catch(error => {
        console.log(error.message);
      });
  },

  loggedIn() {
    return store.getters.user.isLoggedIn;
  },

  isAdmin() {
    return store.getters.user.isAdmin;
  }
};



// WEBPACK FOOTER //
// ./src/services/auth.js